import React from 'react';
import Anchor from '../../components/link/Anchor';
import OpenReturnExchangeAttachment from '../../containers/app/common/OpenReturnExchangeAttachment';
import { asyncSimpleModal } from '../common';
import {
  ORDER_PROCESS_HISTORY_RETURN_EXCHANGE_TYPE_LIST,
  RETURN_EXCHANGE_REASON_TYPE,
  ORDER_DELIVERY_TYPE,
} from '../../constants/service/app/orderConstants';

/**
 *  주문 메시지 설정하기
 */
export const setOrderMessage = (orderMessage, text = '확인하기') => {
  if (!orderMessage) return '-';

  return (
    <Anchor
      color="primary"
      isUnderLine={true}
      text={text}
      onClick={async () =>
        await asyncSimpleModal({
          type: 'info',
          title: '주문 메시지',
          message: orderMessage,
        })
      }
    />
  );
};

/**
 *  주문 이력에서 사유 설정하기
 */
export const setOrderProcessingHistoryReason = (data) => {
  const { status, orderReturnId, orderExchangeId, type, reason } = data;

  /**
   *  반퓸 요청, 반품 거부, 교환 요청, 교환 거부 일때만 상세 이미지를 띄우는 모달을 불러오도록 하고
   *  나머지 타입은 asyncSimpleModal 로 reason 을 보여주도록 한다.
   */
  if (ORDER_PROCESS_HISTORY_RETURN_EXCHANGE_TYPE_LIST.includes(status)) {
    return (
      <OpenReturnExchangeAttachment
        title={
          orderReturnId
            ? type
              ? '반품사유'
              : '반품 거부사유'
            : orderExchangeId
              ? type
                ? '교환사유'
                : '교환 거부사유'
              : ''
        }
        orderReturnExchangeId={orderReturnId ? orderReturnId : orderExchangeId}
        type={
          orderReturnId
            ? type
              ? RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST
              : RETURN_EXCHANGE_REASON_TYPE.RETURN_REJECT
            : orderExchangeId
              ? type
                ? RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REQUEST
                : RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REJECT
              : ''
        }
        text={type ? type : '사유 보기'}
        reason={reason}
      />
    );
  } else {
    if (reason) {
      return (
        <Anchor
          color="primary"
          isUnderLine
          onClick={async () =>
            await asyncSimpleModal({
              title: type ? type : '사유 보기',
              message: reason,
            })
          }
          text={type ? type : '사유 보기'}
        />
      );
    } else {
      return '-';
    }
  }
};

/**
 * 택배방법, 택배사, 송장번호 설정하기
 * 택배방법이 택배, 등기, 소포가 아닌 경우에는
 * 택배사, 송장번호를 초기화해야함
 */
export const setDeliveryInfo = (data) => {
  let deliveryInfo = { ...data };
  if (deliveryInfo.deliveryType !== ORDER_DELIVERY_TYPE.PARCEL_DELIVERY) {
    deliveryInfo = {
      /**
       *  택배방법
       */
      deliveryType: deliveryInfo.deliveryType,
      /**
       *  택배사 선택
       */
      deliveryAgentId: null,
      /**
       *  송장번호
       */
      invoiceNumber: null,
    };
  }

  return deliveryInfo;
};

/**
 *  구매자 ID 일부분만 보이기
 */
export const setBuyerAccount = (account) => {
  return account ? account.slice(0, 4) + '****' : '-';
};
